import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "popover", "popoverButton", "housingPopoverButton", "twinRoomsPopoverButton", "toggleButton", "toggleButtonHiddenField"]
  static outlets = ["venue-search", "activity-search", "caterer-search"]

  venueSearchOutletConnected() {
    this.activeSearch = this.venueSearchOutlet;
  }

  activitySearchOutletConnected() {
    this.activeSearch = this.activitySearchOutlet;
  }

  catererSearchOutletConnected() {
    this.activeSearch = this.catererSearchOutlet;
  }

  submitToggle() {
    let shouldSubmit = false

    this.inputTargets.forEach((input) => {
      if (input.type == "checkbox" || input.type == "radio" || input.type == "hidden") {
        const booleanCheckboxInput = Array.from((this.activeSearch.formTarget.elements)).find((f) => (f.name == input.name && f.type == "checkbox" && f.value == "1"))

        if (["0", "1"].includes(input.value) && booleanCheckboxInput) {
          const inputHasChanged = input.value == "1" && !booleanCheckboxInput.checked || input.value == "0" && booleanCheckboxInput.checked

          shouldSubmit = inputHasChanged
          booleanCheckboxInput.checked = input.value == "1"
        } else {
          const venueSearchFormInput = Array.from((this.activeSearch.formTarget.elements)).find((f) => (f.name == input.name && f.value == input.value))
          if (!venueSearchFormInput) return

          shouldSubmit = input.checked != venueSearchFormInput.checked
          venueSearchFormInput.checked = input.checked
        }
      } else {
        const venueSearchFormInput = Array.from((this.activeSearch.formTarget.elements)).find((f) => f.name == input.name)
        if (!venueSearchFormInput) return

        shouldSubmit = input.value != venueSearchFormInput.value
        venueSearchFormInput.value = input.value
      }
    })


    if (!shouldSubmit) return

    this.activeSearch.pushFormParamsToUrl()
    this.activeSearch.submitForm()
  }

  submitPopover() {
    let shouldSubmit = false

    this.inputTargets.forEach((input) => {
      if (input.type == "checkbox" || input.type == "radio") {
        const searchFormInput = Array.from((this.activeSearch.formTarget.elements)).find((f) => (f.name == input.name && f.value == input.value))
        if (!searchFormInput) return
        if (input.checked != searchFormInput.checked) shouldSubmit = true

        searchFormInput.checked = input.checked
      } else {
        const searchFormInput = Array.from((this.activeSearch.formTarget.elements)).find((f) => f.name == input.name)
        if (!searchFormInput) return
        if (input.value != searchFormInput.value) shouldSubmit = true

        searchFormInput.value = input.value
      }
    })

    if (!shouldSubmit) return

    this.activeSearch.pushFormParamsToUrl()
    this.activeSearch.submitForm()
  }

  submitOnClose(event) {
    const shouldSubmit = !this.popoverTarget.contains(event.target)
                          && !(!this.element.contains(event.target) && this.popoverTarget.parentElement.classList.contains("d-none"))
                            && !(this.element.contains(event.target) && !this.popoverTarget.parentElement.classList.contains("d-none"))

    if (!shouldSubmit) return

    this.submitPopover()
  }

  submitAndClose(event) {
    this.popoverTarget.parentElement.classList.add("d-none")
    this.submitPopover()
  }

  toggleToggleButton(event) {
    if (event.params.fieldKind == "array") {
      this.toggleButtonHiddenFieldTarget.checked = !this.toggleButtonHiddenFieldTarget.checked
    } else if (event.params.fieldKind == "boolean") {
      if (this.toggleButtonHiddenFieldTarget.value == "1") {
        this.toggleButtonHiddenFieldTarget.value = "0"
      } else {
        this.toggleButtonHiddenFieldTarget.value = "1"
      }
    }

    this.toggleButtonTarget.classList.toggle("btn-outline-dark")
    this.toggleButtonTarget.classList.toggle("focus")
    this.toggleButtonTarget.classList.toggle("btn-check")
    this.submitToggle()
  }
}
